import React from 'react';
import { Skeleton } from '@welbe/web-design-system';

import { InfoLabel } from './components/InfoLabel/InfoLabel';
import { InfoCard } from './components/InfoCard/InfoCard';
import { Header } from './components/Header/Header';

import { useProgressDetails } from './ProgressDetails.hooks';
import {
	Container,
	ContainerProgressBar,
	Wrapper,
	ContainerProgressBarSkeleton,
} from './ProgressDetails.styles';

interface ProgressDetailsProps {
	campaignId: string;
	onSelectBranchOfficeId: (branchOfficeId: string) => void;
	selectedBranchOfficeId: string;
}

export const ProgressDetails = ({
	campaignId,
	onSelectBranchOfficeId: handleSelectBranchOfficeId,
	selectedBranchOfficeId,
}: ProgressDetailsProps): JSX.Element => {
	const { isLoading, progressDetailsData } = useProgressDetails({
		campaignId,
	});

	if (isLoading) {
		return (
			<Container>
				<ContainerProgressBarSkeleton>
					{[...Array(10).keys()].map((item) => (
						<Skeleton height="64px" key={item} />
					))}
				</ContainerProgressBarSkeleton>
			</Container>
		);
	}

	return (
		<Wrapper>
			<Header />
			<Container>
				<ContainerProgressBar>
					{progressDetailsData.map((progressDetail: any) => (
						<InfoCard
							totalEmployees={progressDetail.totalEmployees}
							answeredEmployees={progressDetail.answeredEmployees}
							isNomCompleted={progressDetail.isNomCompleted}
							onClick={() => handleSelectBranchOfficeId(progressDetail.id)}
							key={progressDetail.id}
							branchOfficeName={progressDetail.branchOfficeName}
							porcent={progressDetail.porcent}
							highlight={selectedBranchOfficeId === progressDetail.id}
						/>
					))}
				</ContainerProgressBar>
			</Container>
			<InfoLabel />
		</Wrapper>
	);
};
